/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useForm, Controller, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Grid from '@mui/material/Grid';
import { Autocomplete, Box, Checkbox, Chip, Divider, FormControlLabel, FormLabel, TextField } from '@mui/material';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useSelector } from 'react-redux';
import type { BrandApiResponse1, BrandListPropType, RootState, appConfigs } from '../types/types';
import { getAllBrand } from 'src/services/brandService';
import { getAllGroup } from 'src/services/groupService';
import { getAlltemplate } from 'src/services/templateService';
import { addNewCampaign } from 'src/services/campaignService';
import * as EmailValidator from 'email-validator';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { BRAND_TOOLTIP, BRAND_TOOLTIP_MESSAGE, CAMPAIGN_NAME_TOOLTIP, CAMPAIGN_NAME_TOOLTIP_MESSAGE, COOLDOWN_PERIOD_TOOLTIP, ERR_EMAIL, ERR_EMAIL_INVALID, GROUP_TOOLTIP, GROUP_TOOLTIP_MESSAGE, MAXIMUM_RESEND_TOOLTIP, MAXIMUM_RESEND_TOOLTIP_MESSAGE, RESEND_INTERVAL_TOOLTIP, RESEND_INTERVAL_TOOLTIP_MESSAGE,COOLDOWN_PERIOD_TOOLTIP_MESSAGE, UNKNOWN_ERR, UNSUBSCRIBE_LEVELS, BULK_CLIENT_CAMPAIGN_ID } from 'src/constants/constant';
import { HugeiconsIcon } from '@hugeicons/react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { ViewStrokeRounded, Image03Icon } from '@hugeicons-pro/core-stroke-rounded';
import TemplatePreview from '../TemplatePreview/TemplatePreview';

import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
//@ts-ignore
import { HelpCircleIcon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { Calendar03Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
import { checkEventPermission } from 'src/common/utility/utility';
import { getAllSuppressionListByClientId } from "src/services/suppressionListService";

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
}));


export interface NewCampaignInputs {
    clientId?: number;
    groupId?: string | null;
    brandId?: string | null;
    templateId: string;
    name: string;
    description?: string;
    startOn: string;
    endOn: string;
    createdBy?: number;
    unopenedResendDayGap?: number | null;
    resendMaxLimit?: number;
    doNotRepeatEmailDays?: number;
    hourlyMaxSendCount?: number;
    dailyMaxSendCount?: number;
    emailSendStartTime?: string;
    emailSendEndTime?: string;
    unsubscribeTypeId?: string;
    suppressionListId?: string | null;
    clientCampaignId?: string | null;

}

interface GroupListPropType {
    "id": number;
    "clientId": number;
    "clientName": string;
    "groupName": string;
    "isDeleted": boolean;
    "createdBy": number;
    "createdByUserName": string;
    "createdOn": string;
    "modifiedBy": number;
    "modifiedOn": string;
    "modifiedByUserName": string;
    "cooldownPeriod": number;
}

interface GroupApiResponse {
    status: number;
    data: {
        data: GroupListPropType[];
        result: number;
    };
}

interface TemplateListPropType {
    id: number;
    litmusId?: number;
    parentId?: number;
    createdBy?: number;
    clientId?: number;
    templateName: string;
    templateContent: string;
    templateIdentifier?: string;
    subjectLine: string;
    fromName: string;
    fromEmail: string;
    preheader: string;
    resendSubjectLine: string;
    resendPreheader: string;
    status: number;
    templateVersion:number;
}

interface TemplateApiResponse {
    status: number;
    data: {
        data: TemplateListPropType[];
        result: number;
    };
}

interface SuppressionListPropType {
  suppressionList: any;
  suppressionListData: any[];
}

interface SuppressionApiResponse {
  status: number;
  data: {
    data: SuppressionListPropType[];
    result: number;
  };
}


const NewCampaing: React.FC = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [brands, setBrands] = useState<any>([])
    const [groups, setGroups] = useState<any>([])
    const [emailTemplates, setEmailTemplates] = useState<any>([])
    const [selectedGroup, setSelectedGroup] = useState<GroupListPropType | null>(null);
    const [cooldownPeriod, setCooldownPeriod] = useState<number | null>(null);
    const [isCooldownDisabled, setIsCooldownDisabled] = useState<boolean>(false);
    const [selectedTemplate, setSelectedTemplate] = useState<TemplateListPropType | null>(null);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const storedAppConfig = localStorage.getItem("appConfigs");
    const [imageError, setImageError] = useState(false);
    const [suppressionList, setSuppressionList] = useState<any[]>([]);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const parsedAppConfig = storedAppConfig
        ? (JSON.parse(storedAppConfig) as appConfigs[])
        : [];

    const TemplateImagePublicURL = parsedAppConfig.find(
        (item) => item.configName === "TemplateImagePublicURL"
    )?.configValue;

    const ResendMaxValue: any = parsedAppConfig.find(
        (item) => item.configType === "CampaignSettings" && item.configName === "ResendMaxValue"
    )?.configValue;

    const ResendDefaultValue = parsedAppConfig.find(
        (item) => item.configName === "ResendDefaultValue")?.configValue;

    const ResendMaxInterval = parsedAppConfig.find(
        (item) => item.configName === "ResendMaxInterval")?.configValue;

    const ResendDefaultInterval = parsedAppConfig.find(
        (item) => item.configName === "ResendDefaultInterval")?.configValue;

    const CooldownMaxPeriod = parsedAppConfig.find(
        (item) => item.configName === "CooldownMaxPeriod")?.configValue;

    const CooldownDefaultPeriod = parsedAppConfig.find(
        (item) => item.configName === "CooldownDefaultPeriod")?.configValue;

    
    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Please enter the campaign name"),
        startOn: Yup.string().required("Please enter the campaign start date")
            .test("valid-date", "Invalid date format", (value) =>
                moment(value, "YYYY-MM-DD", true).isValid()
            ),
        endOn: Yup.string().required("Please enter the campaign end date")
            .test("valid-date", "Invalid date format", (value) =>
                moment(value, "YYYY-MM-DD", true).isValid()
            )
            .test("endAfterStart", "End date must be after start date", function (value) {
                const { startOn } = this.parent;
                return moment(value, "YYYY-MM-DD").isSameOrAfter(moment(startOn, "YYYY-MM-DD"));
            }),
        templateId: Yup.string().required("Please select email template"),
        resendMaxLimit: Yup.number().typeError("Value must be a number").min(0, "Value cannot be negative").max(ResendMaxValue ? parseInt(ResendMaxValue, 10) : 3, "Value cannot be greater than " + (ResendMaxValue ? ResendMaxValue : 3)),
        doNotRepeatEmailDays: Yup.number().typeError("Value must be a number").min(1, "Value should be greater than 0").max(CooldownMaxPeriod ? parseInt(CooldownMaxPeriod, 10) : 30, "Value cannot be greater than " + (CooldownMaxPeriod ? CooldownMaxPeriod : 30)),
        unopenedResendDayGap: Yup.number()
            .nullable()
            .transform((value, originalValue) =>
                String(originalValue).trim() === '' ? null : value
            )
            .typeError("Value must be a number")
            .when('resendMaxLimit', {
                is: (val:any) => val > 0,
                then: (schema) =>
                schema
                    .required("Resend interval is required")
                    .min(1, "Value should be greater than 0")
                    .max(
                    ResendMaxInterval ? parseInt(ResendMaxInterval, 10) : 14,
                    `Value cannot be greater than ${ResendMaxInterval ? parseInt(ResendMaxInterval, 10) :  14}`
                    ),
                otherwise: (schema) => schema.notRequired().nullable(),
            }),
        clientCampaignId: Yup.string()
            .max(100, 'Client Campaign ID cannot exceed 100 characters')
            .notRequired(),
        // unsubscribeTypeId: Yup.string().required("Please select unsubscribe level"),
    });


    const navigate = useNavigate()

    const { user } = useSelector((state: RootState) => state.auth);

    useEffect(() => {
        const ClientId = user?.clientId ?? 0;
        getAllBrand(ClientId)
            .then(
                (res: BrandApiResponse1) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            const brandArr: BrandApiResponse1[] = [];
                            res.data.data.map((brand: any) => {
                                brand.Name = `${brand.clientName}`
                                brandArr.push(brand)
                            })
                            setBrands(brandArr)
                        } else {
                            setBrands([])
                        }
                    }
                }
            )
            .catch(
                (error: any) => console.log("Error: ", error)
            )


        getAllGroup(ClientId)
            .then(
                (res: GroupApiResponse) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            const webhookArr: GroupListPropType[] = res.data.data.map((webhook: any) => ({
                                ...webhook, // Keep existing properties
                                Name: webhook.clientName, // Assign Name from clientName
                                cooldownPeriod: webhook.cooldownPeriod, // Ensure cooldownPeriod is assigned correctly
                            }));
                            setGroups(webhookArr)
                        } else {
                            setGroups([])
                        }
                    }
                }
            )
            .catch(
                (error: any) => console.log("Error: ", error)
            )

        getAlltemplate(ClientId)
            .then((res: TemplateApiResponse) => {
              if (res.status === 200) {
                const templateArr = res.data.data
                  .filter((template: any) => 
                    template.statusName === "Approved" && template.isDeleted !== 1
                  )
                  .map((template: any) => ({
                    ...template,
                    Name: template.templateName
                  }))
                  .sort((a, b) => a.Name.localeCompare(b.Name)); 
          
                setEmailTemplates(templateArr);
              }
            })
            .catch(
                (error: any) => console.log("Error: ", error)
            );

        getAllSuppressionListByClientId(ClientId)
            .then((res: SuppressionApiResponse) => {
                if (res.status === 200) {
                if (res.data.result === 1) {
                    const suppressionListArr = res.data.data.map((item) => item.suppressionList);
                    setSuppressionList(suppressionListArr);
                } else {
                    setSuppressionList([]);
                }
                }
            })
            .catch((error: any) => console.log("Error: ", error));

    }, [user])

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm<NewCampaignInputs>({
        resolver: yupResolver(validationSchema),
    });

    const handleSubmitClick = (): void => {
        console.log("Submit")
    }

    const onSubmit = async (data: NewCampaignInputs): Promise<void> => {
        setIsLoading(true)

        data.createdBy = user?.id ?? 0;
        data.clientId = user?.clientId ?? 0;

        // Convert startOn and endOn to Moment for validation
        const startDate = moment(data.startOn);
        const endDate = moment(data.endOn);

        // Check if endDate is earlier than startDate
        if (endDate.isBefore(startDate)) {
            NotificationManager.error('End date must be after start date', '', 5000);
            setIsLoading(false);
            return;
        }
        data.startOn = moment(data.startOn).format('YYYY-MM-DD');
        data.endOn = moment(data.endOn).format('YYYY-MM-DD');
        data.hourlyMaxSendCount = 0;
        data.dailyMaxSendCount = 0;
        data.brandId = data.brandId !== "" ? data.brandId : null
        data.groupId = data.groupId !== "" ? data.groupId : null
        data.suppressionListId = data.suppressionListId && data.suppressionListId.length > 0 ? data.suppressionListId : null;
        data.unopenedResendDayGap = data.unopenedResendDayGap ? data.unopenedResendDayGap : 0;
        data.unsubscribeTypeId = "2";
        data.clientCampaignId = data.clientCampaignId !== "" ? data.clientCampaignId : null;
        try {
            const res = await addNewCampaign(data);

            if (res.status === 200) {
                if (res.data.result === 1) {
                    // NotificationManager.success('Campaign added successfully');
                    // refreshPage();
                    navigate(`/campaigns/summary/add/${res.data.data}`)
                } else {
                    const errorMsg: any = res.data.messages[0].message
                    NotificationManager.error(errorMsg.includes('A campaign with the same name already exists for this client') === true ? 'Campaign name already exists' : UNKNOWN_ERR, '', 5000);
                }
            }
        } catch (error) {
            console.error('Error occurred:', error);
            NotificationManager.error('Unknown error has occurred');
        } finally {
            setIsLoading(false);
        }
    }

    const handleCancel = (): void => {
        navigate('/campaigns')
    }

    // Handle group selection
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const handleGroupChange = (event: any, value: GroupListPropType | null) => {
        setSelectedGroup(value);
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (value && value.cooldownPeriod !== undefined && value.cooldownPeriod !== null) {
            // If the selected group has a cooldown period, use it and disable the input field
            setCooldownPeriod(value.cooldownPeriod);
            setValue('doNotRepeatEmailDays', value.cooldownPeriod);
            setIsCooldownDisabled(true); // Disable the input field
        } else {
            // If the selected group does not have a cooldown period, set a default value and enable the input field
            setCooldownPeriod(0);
            setValue('doNotRepeatEmailDays', 30); // Default value
            setIsCooldownDisabled(false); // Enable the input field
        }
    };

    useEffect(() => {
      setImageError(false);
    }, [selectedTemplate?.templateIdentifier]);
console.log(selectedTemplate);

    return (
       
                <div className="flex justify-between items-center">
                    <div className="w-full">
                        <div>
                            <h1 className="text-2xl text-title font-semibold">New Trigger Email</h1>
                            <Box sx={{ flexGrow: 1 }}>
                                <div className='campaign-form-container'>
                                    <form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            void handleSubmit(onSubmit)(e);
                                        }}
                                    >
                                        <Grid container spacing={2}>
                                            <Grid item xs={8} sx={{ paddingRight: '20px' }}>

                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <div className="mb-[30px]">
                                                            <Controller
                                                                name="name"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field }) => (
                                                                    <>
                                                                        <TextField
                                                                            {...field}
                                                                            fullWidth
                                                                            autoComplete="off"
                                                                            label='Campaign Name*'
                                                                            // placeholder="Campaign Name"
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <BootstrapTooltip title={CAMPAIGN_NAME_TOOLTIP_MESSAGE} sx={{ cursor: 'pointer' }}>
                                                                                        <InputAdornment position="end" >

                                                                                            <HugeiconsIcon
                                                                                                icon={HelpCircleIcon}
                                                                                                size={18}
                                                                                                color="#3A3A3A"
                                                                                                strokeWidth={0.2}
                                                                                            />

                                                                                        </InputAdornment>
                                                                                    </BootstrapTooltip >
                                                                                ),
                                                                            }}
                                                                            error={Boolean(errors.name)}
                                                                        />
                                                                        {errors.name && (
                                                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                {errors.name?.message} {/* Show the error message */}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={2}>
                                                    <Grid item xs={6}>
                                                        <div className="mb-[30px]">
                                                            <Controller
                                                                name="startOn"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field }) => (
                                                                    <>
                                                                        <div className="datepicker-container">
                                                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                                <DemoContainer components={['DatePicker']}>
                                                                                    <DatePicker
                                                                                        label="Campaign Start Date*"
                                                                                        onChange={(newValue) => field.onChange(moment(newValue).format("YYYY-MM-DD"))}
                                                                                        minDate={moment()} // Use moment for minDate
                                                                                        dayOfWeekFormatter={(day) => day.format('ddd')}
                                                                                        slotProps={{
                                                                                            textField: ({ position }) => ({
                                                                                                error: errors.startOn && Boolean(errors.startOn),
                                                                                            }),
                                                                                        }}
                                                                                        slots={{
                                                                                            openPickerIcon: () => (
                                                                                                <HugeiconsIcon
                                                                                                    icon={Calendar03Icon}
                                                                                                    size={18}
                                                                                                    color="#3A3A3A"
                                                                                                    strokeWidth={0.5}
                                                                                                />
                                                                                            )
                                                                                        }}
                                                                                    />
                                                                                </DemoContainer>
                                                                            </LocalizationProvider>
                                                                        </div>
                                                                        {errors.startOn && (
                                                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                {errors.startOn?.message} {/* Show the error message */}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <div className="mb-[30px]">
                                                            <Controller
                                                                name="endOn"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field }) => (
                                                                    <>
                                                                        <div className='datepicker-container'>
                                                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                                <DemoContainer components={['DatePicker']}>
                                                                                    <DatePicker
                                                                                        label="Campaign End Date*"
                                                                                        onChange={(newValue) => field.onChange(moment(newValue).format("YYYY-MM-DD"))}
                                                                                        minDate={moment()} // Use moment for minDate
                                                                                        dayOfWeekFormatter={(day) => day.format('ddd')}
                                                                                        slotProps={{
                                                                                            textField: ({ position }) => ({
                                                                                                error: errors.endOn && Boolean(errors.endOn),
                                                                                            }),
                                                                                        }}
                                                                                        slots={{
                                                                                            openPickerIcon: () => (
                                                                                                <HugeiconsIcon
                                                                                                    icon={Calendar03Icon}
                                                                                                    size={18}
                                                                                                    color="#3A3A3A"
                                                                                                    strokeWidth={0.5}
                                                                                                />
                                                                                            )
                                                                                        }}
                                                                                    />
                                                                                </DemoContainer>
                                                                            </LocalizationProvider>
                                                                        </div>
                                                                        {errors.endOn && (
                                                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                {errors.endOn?.message} {/* Show the error message */}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={2}>
                                                    <Grid item xs={6}>
                                                        <div className="mb-[30px]">
                                                            <Controller
                                                                name="brandId"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field }) => (

                                                                    <Autocomplete
                                                                        options={brands} // The list of roles
                                                                        getOptionLabel={(option: any) => option.brandName} // Display roleName
                                                                        popupIcon={
                                                                            <HugeiconsIcon
                                                                                icon={ArrowDown01Icon}
                                                                                size={18}
                                                                                color="#3A3A3A"
                                                                                strokeWidth={0.5}

                                                                            />
                                                                        }
                                                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                                        //@ts-ignore
                                                                        isOptionEqualToValue={(option, value) => option.id === value} // Match by roleId
                                                                        value={brands.find((brand: BrandListPropType) => brand.id.toString() === field.value)} // Current value matching
                                                                        onChange={(_, selectedBrand) => {
                                                                            const id = selectedBrand?.id; // Handle null cases
                                                                            field.onChange(id); // Update form state
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <>
                                                                                <TextField
                                                                                    {...params}
                                                                                    label="Brand"
                                                                                    // placeholder="Select Brand"
                                                                                    InputProps={{
                                                                                        ...params.InputProps,
                                                                                        endAdornment: (
                                                                                            <React.Fragment>
                                                                                                {/* Position the clear icon before the tooltip */}
                                                                                                {params.InputProps.endAdornment && (
                                                                                                    <InputAdornment position="end" sx={{ position: 'absolute', right: '40px' }}>
                                                                                                        {params.InputProps.endAdornment}
                                                                                                    </InputAdornment>
                                                                                                )}

                                                                                                <BootstrapTooltip title={BRAND_TOOLTIP_MESSAGE} sx={{ cursor: 'pointer' }}>
                                                                                                    <InputAdornment position="end" sx={{ position: 'absolute', right: '13px' }}>

                                                                                                        <HugeiconsIcon
                                                                                                            icon={HelpCircleIcon}
                                                                                                            size={18}
                                                                                                            color="#3A3A3A"
                                                                                                            strokeWidth={0.2}
                                                                                                        />

                                                                                                    </InputAdornment>
                                                                                                </BootstrapTooltip >
                                                                                            </React.Fragment>
                                                                                        ),
                                                                                    }}
                                                                                    error={Boolean(errors.brandId)}
                                                                                />
                                                                                {errors.brandId && (
                                                                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                        <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                        {errors.groupId?.message} {/* Show the error message */}
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <div className="mb-[30px]">
                                                            <Controller
                                                                name="groupId"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field }) => (

                                                                    <Autocomplete
                                                                        options={groups}
                                                                        getOptionLabel={(option: any) => option.groupName}
                                                                        popupIcon={
                                                                            <HugeiconsIcon
                                                                                icon={ArrowDown01Icon}
                                                                                size={18}
                                                                                color="#3A3A3A"
                                                                                strokeWidth={0.5}

                                                                            />
                                                                        }
                                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                                        value={groups.find((group: GroupListPropType) => group.id.toString() === field.value)}
                                                                        onChange={(_, selectedGroup) => {
                                                                            const id = selectedGroup?.id;
                                                                            field.onChange(id);
                                                                            handleGroupChange(_, selectedGroup);
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <>
                                                                                <TextField
                                                                                    {...params}
                                                                                    label="Group"
                                                                                    // placeholder="Select Group"
                                                                                    InputProps={{
                                                                                        ...params.InputProps,
                                                                                        endAdornment: (
                                                                                            <React.Fragment>
                                                                                                {/* Position the clear icon before the tooltip */}
                                                                                                {params.InputProps.endAdornment && (
                                                                                                    <InputAdornment position="end" sx={{ position: 'absolute', right: '40px' }}>
                                                                                                        {params.InputProps.endAdornment}
                                                                                                    </InputAdornment>
                                                                                                )}

                                                                                                <BootstrapTooltip title={GROUP_TOOLTIP_MESSAGE} sx={{ cursor: 'pointer' }}>
                                                                                                    <InputAdornment position="end" sx={{ position: 'absolute', right: '13px' }}>

                                                                                                        <HugeiconsIcon
                                                                                                            icon={HelpCircleIcon}
                                                                                                            size={18}
                                                                                                            color="#3A3A3A"
                                                                                                            strokeWidth={0.2}
                                                                                                        />

                                                                                                    </InputAdornment>
                                                                                                </BootstrapTooltip >
                                                                                            </React.Fragment>
                                                                                        ),
                                                                                    }}
                                                                                    error={Boolean(errors.groupId)}
                                                                                />
                                                                                {errors.groupId && (
                                                                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                        <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                        {errors.groupId?.message} {/* Show the error message */}
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <div className="mb-[30px]">
                                                            <Controller
                                                                name="templateId"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field }) => (

                                                                    <Autocomplete
                                                                        options={emailTemplates} // The list of roles
                                                                        getOptionLabel={(option: any) => option.templateName} // Display roleName
                                                                        popupIcon={
                                                                            <HugeiconsIcon
                                                                                icon={ArrowDown01Icon}
                                                                                size={18}
                                                                                color="#3A3A3A"
                                                                                strokeWidth={0.5}

                                                                            />
                                                                        }
                                                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                                        //@ts-ignore
                                                                        isOptionEqualToValue={(option, value) => option.id === value} // Match by roleId
                                                                        value={emailTemplates.find((emailTemplate: TemplateListPropType) => emailTemplate.id.toString() === field.value)} // Current value matching
                                                                        onChange={(_, selectedTemplate) => {
                                                                            const id = selectedTemplate?.id; // Handle null cases
                                                                            field.onChange(id); // Update form state
                                                                            setSelectedTemplate(selectedTemplate);
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <>
                                                                                <TextField
                                                                                    {...params}
                                                                                    label="Email Template*"
                                                                                    // placeholder="Select Email template"
                                                                                    error={Boolean(errors.templateId)}
                                                                                />
                                                                                {errors.templateId && (
                                                                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                        <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                        {errors.templateId?.message} {/* Show the error message */}
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                        disableClearable // Prevent the clear button
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                {/* <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <div className="mb-[30px]">
                                                            <Controller
                                                                name="unsubscribeTypeId"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field }) => (
                                                                    <Autocomplete
                                                                        options={UNSUBSCRIBE_LEVELS}
                                                                        getOptionLabel={(option: any) => option.label}
                                                                        popupIcon={
                                                                            <HugeiconsIcon
                                                                                icon={ArrowDown01Icon}
                                                                                size={18}
                                                                                color="#3A3A3A"
                                                                                strokeWidth={0.5}
                                                                            />
                                                                        }

                                                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                                                        value={UNSUBSCRIBE_LEVELS.find((level) => level.value === field.value) ?? undefined}
                                                                        onChange={(_, selectedLevel) => {
                                                                            field.onChange(selectedLevel?.value || "");
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <>
                                                                                <TextField
                                                                                    {...params}
                                                                                    label="Unsubscribe Level*"
                                                                                    error={Boolean(errors.unsubscribeTypeId)}
                                                                                />
                                                                                {errors.unsubscribeTypeId && (
                                                                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                        <img src="/assets/images/attention.svg" alt="error" width={12} height={12} className="mr-1" />{errors.unsubscribeTypeId?.message}
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                        disableClearable
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <div className="mb-[30px]">
                                                            <Controller
                                                                name="suppressionListId"
                                                                control={control}
                                                                defaultValue={""}
                                                                render={({ field }) => {
                                                                    const selected = suppressionList.filter((s) =>
                                                                        (field.value ?? "")
                                                                            .split(",")
                                                                            .filter((id) => id) // remove empty
                                                                            .includes(String(s.suppressionListId))
                                                                    );

                                                                    return (
                                                                        <Autocomplete
                                                                            multiple
                                                                            options={suppressionList}
                                                                            popupIcon={
                                                                            <HugeiconsIcon
                                                                                icon={ArrowDown01Icon}
                                                                                size={18}
                                                                                color="#3A3A3A"
                                                                                strokeWidth={0.5}
                                                                            />
                                                                        }
                                                                            disableCloseOnSelect
                                                                            value={selected}
                                                                            getOptionLabel={(option: any) => option.title}
                                                                            isOptionEqualToValue={(option, value) =>
                                                                                option.suppressionListId === value?.suppressionListId
                                                                            }
                                                                            onChange={(_, selectedLists) => {
                                                                                field.onChange(selectedLists.map((s) => String(s.suppressionListId)).join(","));
                                                                            }}
                                                                            renderTags={(tagValue, getTagProps) => (
                                                                                <>
                                                                                    {tagValue.slice(0, 2).map((option, index) => {
                                                                                        const { key, ...tagProps } = getTagProps({ index });
                                                                                        return (
                                                                                            <Chip
                                                                                                key={option.suppressionListId}
                                                                                                label={option.title}
                                                                                                {...tagProps}
                                                                                                size="small"
                                                                                            />
                                                                                        );
                                                                                    })}
                                                                                    {tagValue.length > 2 && (
                                                                                        <span style={{ marginLeft: 8, color: "#666" }}>
                                                                                            +{tagValue.length - 2}
                                                                                        </span>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                            renderOption={(props, option, { selected }) => (
                                                                                <li {...props}>
                                                                                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                                                                                    {option.title}
                                                                                </li>
                                                                            )}
                                                                            renderInput={(params) => (
                                                                                <>
                                                                                    <TextField
                                                                                        {...params}
                                                                                        label="Suppression Lists"
                                                                                        error={Boolean(errors.suppressionListId)}
                                                                                    />
                                                                                    {errors.suppressionListId && (
                                                                                        <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                            <img
                                                                                                src="/assets/images/attention.svg"
                                                                                                alt="error"
                                                                                                width={12}
                                                                                                height={12}
                                                                                                className="mr-1"
                                                                                            />
                                                                                            {errors.suppressionListId?.message}
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                </Grid> */}
                                                <Grid container spacing={2}>
                                                    <Grid item xs={4}>
                                                        <div className="mb-[0px]">
                                                            <Controller
                                                                name="resendMaxLimit"
                                                                control={control}
                                                                defaultValue={ResendDefaultValue ? parseInt(ResendDefaultValue, 10) : 1} // Default value from ResendDefaultValue or 3
                                                                render={({ field }) => (
                                                                    <>
                                                                        <TextField
                                                                            {...field}
                                                                            fullWidth
                                                                            autoComplete="off"
                                                                            label='Maximum Resends'
                                                                            // placeholder="Maximum Resends"
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <BootstrapTooltip title={MAXIMUM_RESEND_TOOLTIP_MESSAGE} sx={{ cursor: 'pointer' }}>
                                                                                        <InputAdornment position="end" >

                                                                                            <HugeiconsIcon
                                                                                                icon={HelpCircleIcon}
                                                                                                size={18}
                                                                                                color="#3A3A3A"
                                                                                                strokeWidth={0.2}
                                                                                            />

                                                                                        </InputAdornment>
                                                                                    </BootstrapTooltip >
                                                                                ),
                                                                            }}
                                                                            error={Boolean(errors.resendMaxLimit)}
                                                                        />
                                                                        {errors.resendMaxLimit && (
                                                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                {errors.resendMaxLimit?.message} {/* Show the error message */}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div className="mb-[0px]">
                                                            <Controller
                                                                name="unopenedResendDayGap"
                                                                control={control}
                                                                defaultValue={ResendDefaultInterval ? parseInt(ResendDefaultInterval, 10) : 5} // Default value from ResendDefaultInterval or 1
                                                                render={({ field }) => (
                                                                    <>
                                                                        <TextField
                                                                            {...field}
                                                                            fullWidth
                                                                            autoComplete="off"
                                                                            label='Resends Interval (days)'
                                                                            // placeholder="Resends Interval (days)"
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <BootstrapTooltip title={RESEND_INTERVAL_TOOLTIP_MESSAGE} sx={{ cursor: 'pointer' }}>
                                                                                        <InputAdornment position="end" >

                                                                                            <HugeiconsIcon
                                                                                                icon={HelpCircleIcon}
                                                                                                size={18}
                                                                                                color="#3A3A3A"
                                                                                                strokeWidth={0.2}
                                                                                            />

                                                                                        </InputAdornment>
                                                                                    </BootstrapTooltip >
                                                                                ),
                                                                            }}
                                                                            error={Boolean(errors.unopenedResendDayGap)}
                                                                        />
                                                                        {errors.unopenedResendDayGap && (
                                                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                {errors.unopenedResendDayGap?.message} {/* Show the error message */}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div className="mb-[0px]">
                                                            <Controller
                                                                name="doNotRepeatEmailDays"
                                                                control={control}
                                                                defaultValue={CooldownDefaultPeriod ? parseInt(CooldownDefaultPeriod, 10) : 30} // Default value from CooldownDefaultPeriod or 30
                                                                render={({ field }) => (
                                                                    <>
                                                                        <TextField
                                                                            {...field}
                                                                            fullWidth
                                                                            autoComplete="off"
                                                                            label='Cooldown Period (days)'
                                                                            // placeholder="Cooldown Period (days)"
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <BootstrapTooltip title={COOLDOWN_PERIOD_TOOLTIP_MESSAGE} sx={{ cursor: 'pointer' }}>
                                                                                        <InputAdornment position="end" >

                                                                                            <HugeiconsIcon
                                                                                                icon={HelpCircleIcon}
                                                                                                size={18}
                                                                                                color="#3A3A3A"
                                                                                                strokeWidth={0.2}
                                                                                            />

                                                                                        </InputAdornment>
                                                                                    </BootstrapTooltip >
                                                                                ),
                                                                            }}
                                                                            error={Boolean(errors.doNotRepeatEmailDays)}
                                                                            disabled={isCooldownDisabled}
                                                                        />
                                                                        {errors.doNotRepeatEmailDays && (
                                                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                {errors.doNotRepeatEmailDays?.message} {/* Show the error message */}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div className="mb-[30px]">
                                                            <Controller
                                                                name="clientCampaignId"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field }) => (
                                                                    <>
                                                                        <TextField
                                                                            {...field}
                                                                            fullWidth
                                                                            autoComplete="off"
                                                                            label='Client Campaign ID'
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <BootstrapTooltip title={BULK_CLIENT_CAMPAIGN_ID} sx={{ cursor: 'pointer' }}>
                                                                                        <InputAdornment position="end" >
                                                                                            <HugeiconsIcon
                                                                                                icon={HelpCircleIcon}
                                                                                                size={18}
                                                                                                color="#3A3A3A"
                                                                                                strokeWidth={0.2}
                                                                                            />
                                                                                        </InputAdornment>
                                                                                    </BootstrapTooltip>
                                                                                ),
                                                                            }}
                                                                            error={Boolean(errors.clientCampaignId)}
                                                                        />
                                                                        {errors.clientCampaignId && (
                                                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                <img src="/assets/images/attention.svg" alt="clientCampaignId" width={12} height={12} className="mr-1" />
                                                                                {errors.clientCampaignId?.message}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                
                                            </Grid>
                                            <Grid item xs={4} sx={{ paddingLeft: '20px' }}>
                                                <div className="flex justify-between mb-[20px]">
                                                    <div className="text-16 font-semibold text-muted">Template Preview</div>
                                                </div>

                                                <div className="relative flex justify-center items-center h-[375px] border border-[#e6ecf2] rounded-lg">
                                                    {/* eslint-disable-next-line @typescript-eslint/strict-boolean-expressions */}
                                                    {!imageError ? (
                                                        <img
                                                            src={`${TemplateImagePublicURL}Template/${selectedTemplate?.templateIdentifier}/${selectedTemplate?.templateVersion}/Template_Large.png`}
                                                            alt="Template Preview"
                                                            className="icon-hover"
                                                            onError={() => setImageError(true)}
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                                        />
                                                    ) : (
                                                        <HugeiconsIcon
                                                            icon={Image03Icon}
                                                            size={50}
                                                            color="#6B7280"
                                                            className="block"
                                                        />
                                                    )}

                                                    {/* Hover View Icon */}
                                                    <div className={`absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg ${selectedTemplate?.templateIdentifier ? 'hover:opacity-100 transition-opacity cursor-pointer' : ''}`} onClick={selectedTemplate?.templateContent ? () => setIsPreviewModalOpen(true) : undefined}>
                                                        <HugeiconsIcon
                                                            icon={ViewStrokeRounded}
                                                            size={24}
                                                            color="currentcolor"
                                                            strokeWidth={0.5}
                                                            className={`cursor-pointer text-white ${selectedTemplate?.templateContent !== undefined && selectedTemplate?.templateContent !== null && selectedTemplate?.templateContent !== ''
                                                                ? ''
                                                                : 'opacity-50 cursor-not-allowed'
                                                                }`}
                                                            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                                                            onClick={selectedTemplate?.templateContent ? () => setIsPreviewModalOpen(true) : undefined}

                                                        />
                                                    </div>
                                                </div>
                                            </Grid>
                                            <TemplatePreview
                                                isOpen={isPreviewModalOpen}
                                                onClose={() => setIsPreviewModalOpen(false)}
                                                content={selectedTemplate?.templateContent ?? ''}
                                            />
                                        </Grid>
                                        <Divider sx={{ color: '#D9D9D9', marginBottom: '30px', marginTop: '30px' }} />
                                                <div className='flex justify-between items-center gap-x-3.5'>
                                                    <OutlineButton color='gray' onClick={handleCancel} disabled={isLoading}>Cancel</OutlineButton>
                                                    <GradientButton type='submit' color='red' onClick={handleCancel} disabled={isLoading || !checkEventPermission('CAMPAIGN_ADD')}>{!isLoading ? 'Create Trigger Email' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                                                </div>
                                    </form>
                                </div>
                            </Box>
                        </div>
                    </div>
                </div>
    )
}

export default NewCampaing